import API from "./api";

/* =========================================================
   ACTIVITY LOG API (Admin only - enforced by backend)
========================================================= */

// filters: { search, user_id, action, module, date_from, date_to, page, limit }
export const getLogs = (filters = {}) =>
  API.get("/activity-logs", { params: filters });

export const getRecentActivity = (limit = 10) =>
  API.get("/activity-logs/recent", { params: { limit } });

export default { getLogs, getRecentActivity };
